<template>
    <div class="card">
        <div class="card-image" @click="openDetail">
            <img v-lazy="data.image" />
        </div>
        <div class="card-info">
            <div class="card-info__title" @click="openDetail">
                <div class="card-info__title-tag">
                    <svg-icon icon-class="recommend0" class-name="icon-recommend0" v-if="data.recommend === 1"></svg-icon>
                    <!-- <svg-icon icon-class="recommend1" class-name="icon-recommend1" v-else-if="data.recommend === 0"></svg-icon> -->
                    <svg-icon icon-class="recommend2" class-name="icon-recommend2" v-else-if="data.recommend === 2"></svg-icon>
                </div>
                <span class="card-info__title-text" :title="data.title || ''">{{ data.title || '' }}</span>
                <span class="card-info__title-follow">
                    <svg-icon icon-class="follow" class-name="icon-follow"></svg-icon>
                    {{data.follow | formatFollow}}
                </span>
            </div>
            <!-- <div class="card-info__action" v-if="data.type !== 5">
                <span class="card-info__action--category" v-if="data.category">
                    {{ data.category }}
                </span>
                <span class="card-info__action--follow">
                    <svg-icon icon-class="follow" class-name="icon-follow"></svg-icon>
                    {{ data.follow || 0 }}
                </span>
                <span class="card-info__action--collect">
                    <svg-icon icon-class="collect" class-name="icon-collect"></svg-icon>
                    {{ data.collect || 0 }}
                </span>
                <span class="card-info__action--like">
                    <svg-icon icon-class="like" class-name="icon-like"></svg-icon>
                    {{ data.like || 0 }}
                </span>
            </div> -->
            <div v-if="data.type !== 5" class="card-info__user" @click="openUserDetail(data.userId)">
                <img class="card-info__user-avatar" v-lazy="data.avatar || avatarUrl" />
                <span>{{ data.name || '无名大师' }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Card',
    props: {
        data: {
            type: Object,
            default: () => {}
        }
    },
    data: () => ({
        avatarUrl: '/static/images/user.png'
    }),
    filters:{
        formatFollow(value) {
            let showValue = 0
            if (value > 1000 && value < 10000) {
                showValue = (value / 1000).toFixed(1) + 'k'
            } else if (value > 10000) {
                showValue = (value / 10000).toFixed(1) + 'w'
            } else {
                showValue = value
            }
            return showValue
        }
    },
    methods: {
        openDetail() {
            this.$emit('openDetail', this.data);
        },
        openUserDetail(id) {
            this.$emit('openUserDetail', id);
        }
    }
};
</script>

<style lang="scss" scoped>
.card {
    width: 300px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 10px 5px 20px 0px rgba(72,78,104,0.02);
    cursor: pointer;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, .03), 0 8px 16px rgba(0, 0, 0, .02);
        transform: translate(0, -5px);
        transition: transform .3s;
    }
    &-image {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
        box-shadow: 0px 2px 8px 0px rgba(153, 154, 172, 0.25);
        border-radius: 8px 8px 0 0;
        overflow: hidden;
        background-color: #fff;
        cursor: pointer;

        img {
            width: 300px;
            height: 200px;
            // border-radius: 8px;
            transition: transform 0.35s;

            &:hover {
                transform: scale(1.05);
            }
        }
    }

    &-info {
        color: rgba(90, 90, 90, 1);
        padding: 0 12px 12px 12px;

        &__title {
            display: flex;
            align-items: center;
            margin-top: 8px;
            cursor: pointer;
            @include font(rgba(39, 44, 64, 1), 16px, 600);

            &-text {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                flex: 1;
                font-weight:400;

                &:hover {
                    color: rgba(47, 84, 235, 1);
                }
            }

            &-follow {
                display: flex;
                align-items: center;
                color: #A8ADC1;
                font-size:12px;
                margin-left: 22px;
                font-weight: 400;
                .icon-follow {
                    margin-right: 4px;
                }
            }

            &-tag {
                .icon-recommend0,
                .icon-recommend1,
                .icon-recommend2 {
                    font-size: 22px;
                    margin-right: 10px;
                }
            }
        }

        &__action {
            display: flex;
            align-items: center;
            font-size: 14px;
            margin-top: 8px;
            color: #a8adc1;

            .icon-follow,
            .icon-collect,
            .icon-like {
                color: #a8adc1;
            }

            &--follow,
            &--collect {
                margin-right: 20px;
            }

            &--category {
                padding: 2px 5px;
                margin-right: 20px;
                background-color: #e1e4f3;
                border-radius: 2px;
                white-space: nowrap;
                @include font(#9b9fb1, 12px, 400);
            }
        }

        &__user {
            display: flex;
            align-items: center;
            margin-top: 8px;
            cursor: pointer;
            @include font(#272c40, 12px, 400);

            &-avatar {
                width: 20px;
                height: 20px;
                border-radius: 50%;
                margin-right: 10px;
            }

            span:hover {
                color: #2f54eb;
            }
        }
    }
}

// 小屏
@include mq($small) {
    .card {
        width: 225px;

        &-image {
            height: 150px;

            img {
                width: 225px;
                height: 150px;
            }
        }

        &-info {
            &__title {
                @include font(rgba(39, 44, 64, 1), 14px, 600);

                &-tag {
                    .icon-recommend0,
                    .icon-recommend1,
                    .icon-recommend2 {
                        font-size: 18px;
                        margin-right: 8px;
                    }
                }
            }
        }
    }
}
</style>
